import React from 'react';
import { SvgHelperWrapper } from '../../Icon/iconHelper';
import wateringCanBadge from '../../Icon/icons/my-words-review-badge.svg';
import gl0 from './gl_0.svg';
import gl1 from './gl_1.svg';
import gl2 from './gl_2.svg';
import gl3 from './gl_3.svg';
import gl4 from './gl_4.svg';
import gl5 from './gl_5.svg';
import fullyGrownFlower from './gl_6.svg';
import alreadyKnown from './already_known.svg';

const Icons = {
  gl0,
  gl1,
  gl2,
  gl3,
  gl4,
  gl5,
  gl6: fullyGrownFlower,
  glreview: wateringCanBadge,
  alreadyKnown,
};

const GLIcon = ({ name }: { name: keyof typeof Icons }) => {
  const IconSVG: React.ComponentType = Icons[name];
  return (
    <div data-testid={name}>
      <SvgHelperWrapper Svg={IconSVG} />
    </div>
  );
};

export default GLIcon;
